module.exports = __webpack_public_path__ + "img/copy.419c8bf2.svg";